import React from "react";

const FooterQRCode: React.FC<{ title: string; imageUrl: string }> = ({
  title,
  imageUrl
}) => {
  return title ? (
    <div className="space-y-2 text-base font-semibold">
      <p className="text-gray-2-light">{title}</p>
      <img className="w-[100px] h-[100px]" src={imageUrl} alt={title} />
    </div>
  ) : null;
};

export default FooterQRCode;
